import type { MutableState } from '../State';

/**
 * Call it on first native app install
 */
export function initializeFirstAppInstall(state: MutableState): void {
  // Player saw promo popup and installed the native app
  // This player will receive reward
  if (state.native.appInstallRewardStatus === 'saw_promo') {
    state.native.appInstallRewardStatus = 'received';
  }

  // Player never saw reward promo this player won't get native instal reward
  if (state.native.appInstallRewardStatus === 'idle') {
    state.native.appInstallRewardStatus = 'rejected';
  }
}
